import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { LandingSurface } from '../models/landing-surface.model';
var EditRunwayComponent = /** @class */ (function () {
    function EditRunwayComponent(_matDialogRef, _snackBar, data, _runwayService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._runwayService = _runwayService;
        this.isNew = false;
        this.isLoading = true;
        this.runway = data.runway || new LandingSurface();
        this.isNew = data.isNew || false;
        this.airportId = data.airID;
        this.origRunway = Object.assign(new LandingSurface, data.runway);
        if (this.isNew) {
            this.selectedRunwayType = '';
            this.selectedCondition = '';
            this.selectedPavementType = '';
            this.selectedEdgeLighting = '';
        }
        else {
            this.selectedRunwayType = this.getRunwayType(this.runway.type);
            this.selectedCondition = this.getRunwayCondition(this.runway.condition);
            this.selectedPavementType = this.getPavementType(this.runway.pavementType);
            this.selectedEdgeLighting = this.getEdgeLighting(this.runway.edgeLighting);
        }
    }
    EditRunwayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            name: new FormControl(this.runway.name, [Validators.required, Validators.maxLength(100)]),
            length: new FormControl(this.runway.length, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(8)]),
            width: new FormControl(this.runway.length, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(8)]),
            type: new FormControl(this.selectedRunwayType),
            materialType1: new FormControl(this.runway.materialType1, [Validators.required, Validators.maxLength(30)]),
            materialType2: new FormControl(this.runway.materialType2, [Validators.maxLength(30)]),
            treatment: new FormControl(this.runway.treatment, [Validators.maxLength(30)]),
            condition: new FormControl(this.selectedCondition, [Validators.required]),
            pavementType: new FormControl(this.selectedPavementType),
            edgeLighting: new FormControl(this.selectedEdgeLighting),
            pcn: new FormControl(this.runway.pcn, [Validators.min(0), Validators.max(999)]),
            subgradeStrength: new FormControl(this.runway.subgradeStrength),
            tirePressure: new FormControl(this.runway.tirePressure),
            wtBearing1Wheel: new FormControl(this.runway.wtBearing1Wheel, [Validators.min(0), Validators.max(9999)]),
            wtBearing2Wheel: new FormControl(this.runway.wtBearing2Wheel, [Validators.min(0), Validators.max(9999)]),
            wtBearing2WheelDblTandem: new FormControl(this.runway.wtBearing2WheelDblTandem, [Validators.min(0), Validators.max(9999)]),
            wtBearing2WheelTandem: new FormControl(this.runway.wtBearing2WheelTandem, [Validators.min(0), Validators.max(9999)])
        });
        this.isLoading = false;
    };
    EditRunwayComponent.prototype.getRunwayType = function (type) {
        return LandingSurface.formatLandingSurfaceType(type);
    };
    EditRunwayComponent.prototype.setRunwayType = function (type) {
        return LandingSurface.parseLandingSurfaceType(type);
    };
    EditRunwayComponent.prototype.getRunwayCondition = function (condition) {
        return LandingSurface.formatCondition(condition);
    };
    EditRunwayComponent.prototype.setRunwayCondition = function (condition) {
        return LandingSurface.parseCondition(condition);
    };
    EditRunwayComponent.prototype.getPavementType = function (pavementType) {
        return LandingSurface.formatPavementType(pavementType);
    };
    EditRunwayComponent.prototype.setPavementType = function (pavementType) {
        return LandingSurface.parsePavementType(pavementType);
    };
    EditRunwayComponent.prototype.getEdgeLighting = function (edgeLighting) {
        return LandingSurface.formatEdgeLighting(edgeLighting);
    };
    EditRunwayComponent.prototype.setEdgeLighting = function (edgeLighting) {
        return LandingSurface.parseEdgeLighting(edgeLighting);
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditRunwayComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        this.runway.name = this.formGroup.value.name;
                        this.runway.length = this.formGroup.value.length;
                        this.runway.width = this.formGroup.value.width;
                        this.runway.type = this.setRunwayType(this.formGroup.value.type);
                        this.runway.materialType1 = this.formGroup.value.materialType1;
                        this.runway.materialType2 = this.formGroup.value.materialType2;
                        this.runway.treatment = this.formGroup.value.treatment;
                        this.runway.condition = this.setRunwayCondition(this.formGroup.value.condition);
                        this.runway.pavementType = this.setPavementType(this.formGroup.value.pavementType);
                        this.runway.edgeLighting = this.setEdgeLighting(this.formGroup.value.edgeLighting);
                        this.runway.pcn = this.formGroup.value.pcn;
                        this.runway.subgradeStrength = this.formGroup.value.subgradeStrength;
                        this.runway.tirePressure = this.formGroup.value.tirePressure;
                        this.runway.wtBearing1Wheel = this.formGroup.value.wtBearing1Wheel;
                        this.runway.wtBearing2Wheel = this.formGroup.value.wtBearing2Wheel;
                        this.runway.wtBearing2WheelTandem = this.formGroup.value.wtBearing2WheelTandem;
                        this.runway.wtBearing2WheelDblTandem = this.formGroup.value.wtBearing2WheelDblTandem;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._runwayService.postRunway(this.airportId, this.runway)];
                    case 1:
                        result = _a.sent();
                        this.runway = LandingSurface.parse(result);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._runwayService.putRunway(this.airportId, this.runway)];
                    case 3:
                        result = _a.sent();
                        this.runway = LandingSurface.parse(result);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, runway: this.runway });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditRunwayComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditRunwayComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.runway, this.origRunway);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditRunwayComponent;
}());
export { EditRunwayComponent };
